/**
 * Hook de traducción. Los copys salen SIEMPRE de @thepit/i18n (S8):
 * la guarda `no-hardcoded-string` impide escribir texto visible en los componentes.
 */
import { useCallback } from 'react';
import { t as translate, type Locale } from '@thepit/i18n';

export type TFunction = (key: string, vars?: Record<string, string | number>) => string;

export function useT(locale?: Locale): TFunction {
  return useCallback<TFunction>((key, vars) => translate(key, vars, locale), [locale]);
}

/** Traducción de un código de error de dominio, con fallback al detalle del servidor. */
export function useErrorText(): (code: string, fallback: string) => string {
  const t = useT();
  return useCallback(
    (code: string, fallback: string) => {
      const key = `error.codes.${code}`;
      const text = t(key);
      return text.startsWith('⟦') ? fallback : text;
    },
    [t],
  );
}

export { translate };
